import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export interface BulkPlanAssignmentRequest {
  targetPlanId: string;
  dealerIds: string[];
  operation: 'add' | 'replace';
  sourcePlanId?: string;
  /**
   * Source of the assignment:
   * - 'admin': From admin screen - preserves financial values when replacing
   * - 'dealerManagement': From dealer management screen - ALL values change
   */
  source?: 'admin' | 'dealerManagement';
}

export interface BulkPlanAssignmentResponse {
  targetPlanId: string;
  operation: 'add' | 'replace';
  source?: string;
  updatedDealers: number;
  skipped?: { dealerId: string; reason: string }[];
}

@Injectable({
  providedIn: 'root'
})
export class PlanMaintainService {

  constructor(private http: HttpClient) { }

  /**
   * Bulk assign or replace plans for multiple dealers.
   * 
   * Behavior:
   * - operation='add': Assigns new plan with ALL values from plan template
   * - operation='replace' with source='admin': Preserves financial values
   *   (planAmount, planGstAmount, planTotalAmount, planNetAmount, gstApplicable, gstShow, planMinimumAmount)
   * - operation='replace' with source='dealerManagement': ALL values change
   */
  bulkAssignPlan(request: BulkPlanAssignmentRequest): Observable<BulkPlanAssignmentResponse> {
    // Default to 'admin' source for backward compatibility
    const requestWithSource = {
      ...request,
      source: request.source || 'admin'
    };
    return this.http.post<BulkPlanAssignmentResponse>(`${environment.apiUrl}/dealer/bulkPlanAssign`, requestWithSource);
  }
}
